import React from "react"

import AppLayout from "./app"

const Layout = ({ children, pageContext }) => {
  if (pageContext.layout === "app") {
    return <AppLayout>{children}</AppLayout>
  }
  return <>{children}</>
}
export default Layout